import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '../../../common/api/http.service';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {APIResponse, Filter} from '@core/interfaces/system/system-common';
import {
    LatestModelStatus,
    FaultIndicationDashboardData,
    RowDataReadingsDashboardData,
} from '@core/interfaces/live/live';
import {HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {OilTemperatureVsMoistureUnits} from '@core/interfaces/live/oil-temperature-moisture';

@Injectable()
export class OilTemperatureMoistureApi {
    private readonly PREFIX = 'live/output/oil-temp-moisture';

    constructor(private api: HttpService) {}

    public getOilTemperatureVsMoistureUnits(): Observable<OilTemperatureVsMoistureUnits> {
        return this.api.get(`${this.PREFIX}/units`);
    }

    public getOilTemperatureVsMoistureDatasource(id: string, filters: Filter[]): Observable<DataSource> {
        return this.api.postServerDataSource(`${this.PREFIX}/list?filterByassetId=${id}`, filters);
    }

    public getCountResults(assetId: string, uploadTime?: string): Observable<number> {
        return this.api
            .get(`${this.PREFIX}/count`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<number>) => res.response));
    }

    public getOilTemperatureVsMoistureLatestModelStatus(
        assetId: string,
        uploadTime?: string,
    ): Observable<LatestModelStatus> {
        return this.api
            .get(`${this.PREFIX}/latest`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<LatestModelStatus>) => res.response));
    }

    public getOilRowDataReadingsDashboardData(
        assetId: string,
        uploadTime?: string,
    ): Observable<RowDataReadingsDashboardData> {
        return this.api
            .get(`${this.PREFIX}/data/raw`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<RowDataReadingsDashboardData>) => res.response));
    }

    public getOilFaultIndicationDashboardData(
        assetId: string,
        uploadTime?: string,
    ): Observable<FaultIndicationDashboardData> {
        return this.api
            .get(`${this.PREFIX}/data/fault-indicator`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<FaultIndicationDashboardData>) => res.response));
    }
}
